import React, {useEffect, useRef} from "react";
import Gif from "../../../imgs/htmlAdvert4/F15-128695-Consilient-Health-Altavita-New-GP-Consult.gif";

export const HTMLAdvert4 = ({hide, onClick}) => {
  const loopRef = useRef(null);

  const handleGifChange = () => {
    const stage = document.querySelector(".stage");
    const durations = [2000,2000,2000];
    const apiFrame  = 2;
    const apiLink   = stage.dataset.apiLink;
    const defLink   = stage.dataset.defaultLink;
    const linkEl    = stage.querySelector(".clickLayer");

    let frame = 0;

    function loop() {
      if(frame === apiFrame){
        linkEl.href = apiLink;
      } else {
        linkEl.href = defLink;
      }

      frame = (frame + 1) % durations.length;
      loopRef.current = setTimeout(loop, durations[frame]);
    }

    loop();
  };

  const handleGifLoad = () => {
    handleGifChange();
  };

  useEffect(() => {
    return () => {
      if (loopRef.current) clearTimeout(loopRef.current);
    };
  }, []);

  return !hide && (
    <div className="stage"
         data-api-link="https://www.consilienthealth.ie/altavita/wp-content/uploads/sites/8/2026/04/Altavita-Full-Range-API-March-2026.pdf?utm_source=GP+Consult+Vit+D+Template&utm_medium=MPU+on+GP+Consult+VIt+D+template+&utm_campaign=Mysimba+awareness+campaign+Vit+D+template&utm_id=Gp+Consult+Vit+D+template&utm_term=GP+Consult+Vit+D+Template&utm_content=GP+Consult+Vit+D+Template"
         data-default-link="https://www.consilienthealth.ie/altavita/?utm_source=GP+Consult+Vitamin+D+Template&utm_medium=MPU+on+GP+Consult+Vitamin+D+template+&utm_campaign=Altavita+Bone+Health+at+every+age+and+stange+vit+D+template&utm_id=Gp+Consult+Vitamin+D+template+&utm_term=GP+Consult+Vitamin+D+Template&utm_content=GP+Consult+Vitamin+D+Template">
      <img src={Gif} alt="Altavita Advert" onLoad={handleGifLoad} />
      <a className="clickLayer" href="#" target="_blank" rel="noopener" onClick={onClick}></a>
    </div>
  );
};